import { Component } from 'preact'

import s from './no-methods.sass'
import CollapsibleSection from '../collapsible-section'
import ActionButton from '../../action-button'

export default class NoMethodsSection extends Component {
  render () {
    return (
      <CollapsibleSection
        className={s.noMethodsSection}
        isCollapsed={false}
      >
        <div className={s.content}>
          <h2>Ojdå...</h2>
          <p className={s.description}>Det verkar som det inte finns några produkter som matchar angivna uppgifter. Detta kan bero på att medlemskapet enbart går att teckna med löpande betalning vilket kräver att den som tecknar medlemskapet har fyllt minst 18 år.</p>
          <ActionButton className={s.goBack} label='Tillbaka' onClick={() => window.history.back()} />
        </div>
      </CollapsibleSection>
    )
  }
}



// WEBPACK FOOTER //
// ./components/signup-flow/step-payment/no-methods.js